/* Surgia: local search inside filter choices, keeping Shopify's native facet update intact. */
(() => {
  if (window.__surgiaFacetSearch) return;
  window.__surgiaFacetSearch = true;
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches('.surgia-facet-search__input')) return;
    // FacetFiltersForm submits on every input event. Search must not trigger
    // a Shopify filter request: it only narrows the visible checkbox labels.
    event.stopPropagation();
    const panel = input.closest('.parent-display, .mobile-facets__submenu');
    const list = panel?.querySelector('.facets__list, .facets__list--vertical, .mobile-facets__list');
    if (!list) return;
    const query = input.value.trim().toLocaleLowerCase();
    const showMore = panel.querySelector('show-more-button');
    const expanded = showMore?.querySelector('.label-show-more')?.classList.contains('hidden');
    for (const item of list.children) {
      const label = item.querySelector('.facet-checkbox__text-label')?.textContent?.trim() || '';
      const initiallyHidden = item.classList.contains('show-more-item') && !expanded;
      item.classList.toggle('hidden', !label.toLocaleLowerCase().includes(query) || (!query && initiallyHidden));
    }
    if (showMore) showMore.classList.toggle('hidden', !!query);
  }, true);
})();
